import { GlobalConstants } from "../constants/global";
import { TCredentials } from "../types/credentials";
import { CookieManager } from "./cookieManager";

class SettingsManager {
    /**
	* Запись данных сессии
	* @param credentials Данные сессии
	*/
	static setConnectionCredentials(credentials: TCredentials) {
		CookieManager.setCookie(GlobalConstants.ConnectionCredentialsProperty, JSON.stringify(credentials), { expires: Date.now() + 86400e3 });
	}

    /**
	* Чтение данных сессии
	* @returns Данные сессии
	*/
	static getConnectionCredentials(): TCredentials {
		let credentials: TCredentials = null;
		const value = CookieManager.getCookie(GlobalConstants.ConnectionCredentialsProperty);
		if (value) {
			credentials = JSON.parse(value);
		}
		return credentials;
	}

    /**
	 * Обновляет данные сессии
	 * @param credentials Данные сессии
	 */
	static updateConnectionCredentials(credentials: TCredentials) {
		const oldCreds = this.getConnectionCredentials();
		if(!oldCreds) {
			this.setConnectionCredentials(credentials);
		}
		else {
			this.setConnectionCredentials({...oldCreds, ...credentials});
		}
	}

	/**
	 * Запись последнего номера, с которого успешно вошли
	 *
	 * Хранится отдельной кукой, а не в данных сессии: `clearConnectionCredentials`
	 * при выходе перезаписывает куку сессии целиком, и номер стёрся бы вместе с ней —
	 * именно он нужен, чтобы подставить его в форму входа после разлогина.
	 * @param phoneNumber Номер из 10 цифр, без кода страны
	 */
	static setLastPhoneNumber(phoneNumber: string) {
		CookieManager.setCookie(GlobalConstants.LastPhoneNumberProperty, phoneNumber, {
			expires: new Date(Date.now() + 365 * 86400e3),
		});
	}

	/**
	 * Чтение последнего номера, с которого успешно вошли
	 * @returns Номер из 10 цифр или пустая строка
	 */
	static getLastPhoneNumber(): string {
		return CookieManager.getCookie(GlobalConstants.LastPhoneNumberProperty) ?? '';
	}

	/**
	 * Забыть последний номер — пользователь решил войти с другого
	 */
	static clearLastPhoneNumber() {
		CookieManager.deleteCookie(GlobalConstants.LastPhoneNumberProperty);
	}

	/**
	 * Очистка данных сессии
	 */
	static clearConnectionCredentials() {
		this.setConnectionCredentials({token: null, userId: null, crmID: null, crmName: null});
	}
}

export { SettingsManager };